<template>
  <transition name="el-fade-in-linear">
    <dialog-model v-if="visible">
      <div class="dialog-sign">
        <div class="head">
          <div class="banner">
            <div class="text">
              {{ description }}获得{{ currentCoin }}枚{{ CONFIG_PROJECT.coin }}
            </div>
          </div>

          <div class="btn-close" @click="close"></div>
        </div>

        <div class="body">
          <div
            v-for="(item, index) in data"
            :key="index"
            class="item"
            :class="{ active: item.checked }"
          >
            <div class="label" :class="{ current: currentDay === item.day }">
              {{ item.label }}
            </div>
            <div class="card">
              <div class="value">+{{ item.coinamount }}</div>
              <div class="icon">
                {{ item.checked ? "√" : "￥" }}
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <el-button type="primary" class="btn-detail" @click="signHandler">
            签到
          </el-button>
          <!-- <el-button 
                    type="primary"
                    class="btn-detail"
                    @click="explainHandler"
                    >
                        查看详情
                    </el-button> -->
        </div>
      </div>
    </dialog-model>
  </transition>
</template>

<script>
import CONFIG_PROJECT from "@config/project";

import dialogModel from "@components/sys/dialog-model";

import { mapGetters } from "vuex";

export default {
  components: {
    dialogModel,
  },
  data: () => ({
    visible: false,

    data: [
      {
        label: "周一",
        day: 1,
        coinamount: 3,
        checked: false,
      },
      {
        label: "周二",
        day: 2,
        coinamount: 1,
        checked: false,
      },
      {
        label: "周三",
        day: 3,
        coinamount: 5,
        checked: false,
      },
      {
        label: "周四",
        day: 4,
        coinamount: 1,
        checked: false,
      },
      {
        label: "周五",
        day: 5,
        coinamount: 10,
        checked: false,
      },
      {
        label: "周六",
        day: 6,
        coinamount: 2,
        checked: false,
      },
      {
        label: "周日",
        day: 0,
        coinamount: 1,
        checked: false,
      },
    ],

    onclose: null,
    CONFIG_PROJECT,
  }),
  computed: {
    ...mapGetters({
      nickname: "userinfo/getNickname",
    }),
    currentDay() {
      return new Date().getDay();
    },
    currentCoin() {
      var day = new Date().getDay();
      return this.data.filter((item) => item.day === day)[0].coinamount;
    },
    description() {
      return this.nickname ? `您今日签到后，将` : `登录签到，`;
    },
  },
  methods: {
    open(obj) {
      this.visible = true;
      this.onclose = obj.onclose || function () {};
      //自动签到
      // this.signHandler();
      this.getSignin();
    },
    close() {
      this.visible = false;
      try {
        this.onclose();
      } catch (e) {
        // e
      }
      this.$emit("close");
    },
    explainHandler() {
      this.close();

      if (this.nickname) {
        // this.goto('/user/assets');
        window.location.assign("/user/assets");
      } else {
        // this.goto({
        //     path: '/login',
        //     query: {
        //         redirect: '/user/assets'
        //     },
        // });
        window.location.assign("/user/assets?redirect=/user/assets");
      }
    },
    signHandler() {
      this.$post(`${this.$store.state.api.webUrl}/usercenter/signin.json`, (data) => {
        this.data = data.signininfolist;
        showMsg(`签到成功`, "success");
        this.close();
      });
    },
    getSignin() {
      this.$get(
        `${this.$store.state.api.webUrl}/usercenter/checkuserstatus.json`,
        (data) => {
          this.data = data.signininfolist;
        }
      );
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
@import "@css/var.scss";

.dialog-sign {
  width: 618px;
  background: white;
  border-radius: 6px;
  position: fixed;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);

  .head {
    position: relative;

    .banner {
      height: 120px;
      background-image: url(./assets/banner.jpg);
      background-size: cover;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;

      .text {
        color: white;
        font-size: 18px;
        text-align: center;
        padding-top: 78px;
      }
    }

    .btn-close {
      position: absolute;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: white;
      right: -16px;
      top: -16px;
      border: 2px solid white;
      box-sizing: border-box;
      cursor: pointer;

      &:before,
      &:after {
        content: "";
        display: bolck;
        width: 2px;
        height: 18px;
        background: #999;
        position: absolute;
        left: 50%;
        top: 50%;
        border-radius: 1px;
      }

      &:before {
        transform: translate(-50%, -50%) rotate(-45deg);
      }

      &:after {
        transform: translate(-50%, -50%) rotate(45deg);
      }

      &:hover {
        background: #999;
      }
      &:hover:before,
      &:hover:after {
        background: white;
      }
    }
  }

  .body {
    overflow: hidden;
    margin: 0 -10px;
    padding: 46px 42px 0;

    .item {
      text-align: center;
      float: left;
      width: 14.28%;
      padding: 0 10px;
      box-sizing: border-box;
      font-size: 18px;
      line-height: 1em;
      font-weight: bold;
    //   cursor: pointer;

      &.active {
        cursor: default;

        // .label{
        //     color: $primaryColor;
        // }
        .card {
          background-color: $primaryColor;

          .value {
            color: white;
          }
        }
      }

      .label {
        color: #666666;

        &.current {
          color: $primaryColor;
        }
      }

      .card {
        width: 100%;
        background: #eee;
        border-radius: 5px;
        padding: 10px 0;
        margin-top: 12px;
        transition: all 0.3s;

        .value {
          color: #999999;
        }

        .icon {
          width: 34px;
          height: 34px;
          line-height: 26px;
          background-color: #f9ab10;
          border: 4px solid #ffd96b;
          box-shadow: 0 0 4px #f9a80a inset;
          box-sizing: border-box;
          margin: 0 auto;
          margin-top: 8px;
          color: white;
          font-size: 16px;
          border-radius: 50%;
        }

        // &:hover{
        //     background-color: $primaryColor;

        //     .value{
        //         color: white;
        //     }
        // }
      }
    }
  }

  .footer {
    text-align: center;
    margin-top: 42px;
    padding-bottom: 42px;

    .btn-detail {
      padding: 14px 30px;
    }
  }
}
</style>
